<script>
	import { getContext } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import {
		add,
		format,
		isBefore,
		isEqual,
		differenceInCalendarDays,
		areIntervalsOverlapping,
		getOverlappingDaysInIntervals,
	} from 'date-fns'
	import { storeRoomConfirm } from '../library/scripts/Store.svelte'
	import { get_room_details } from '../library/scripts/utils.js'
	import DatePicker from '../library/LayoutStuff/DatePicker.svelte'
	import { admin } from '../library/scripts/PhpHandler.svelte'

	export let room = null

	const globals = getContext('globals')
	//the globals
	const fsN = globals.fsN
	const fsS = globals.fsXS
	const colorMain = globals.colorMain
	const colorError = globals.colorError
	const colorSuccess = globals.colorOk
	const fsButton = globals.fsS
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	//error
	let error = false
	let message = ''
	//the dates
	let bookingDates = {}

	//the dates
	let today = new Date()
	let end = add(today, {
		days: 1,
	})

	//format the dates
	today = format(today, 'd/M/y')
	bookingDates.start = today
	bookingDates.end = format(end, 'd/M/y')

	//checkin and checkout as dates
	let checkinDate
	let checkoutDate
	let checkinDay
	let checkoutDay

	//the seasons
	let seasons

	//infos about booking (error,booked,success)
	let infoBooking = ''

	//overlapping intervals
	let overlap = false
	let startCompDate
	let endCompDate

	//days in season
	let daysInSeason = 0
	let daysOffSeason = 0
	let totalDays = 0

	//show button if all dates are set ok
	let checkButton = true
	let bookButton = false

	//the prices
	let total = 0
	let currency
	let guests
	let breakfast

	const check_date = () => {
		//split the dates for comparison
		const now = today.split('/')
		const start = bookingDates.start.split('/')
		if (Object.keys(bookingDates).length > 1) end = bookingDates.end.split('/')

		//start date is before today
		if (isBefore(new Date(start[2], start[1] - 1, start[0]), new Date(now[2], now[1] - 1, now[0]))) {
			infoBooking = ['error', 'wrong check-in date']
			error = true
			const toError = setTimeout(() => {
				error = false
			}, 2500)
			return false
		}

		//end date is before start day
		if (
			isBefore(new Date(end[2], end[1] - 1, end[0]), new Date(start[2], start[1] - 1, start[0])) ||
			isEqual(new Date(end[2], end[1] - 1, end[0]), new Date(start[2], start[1] - 1, start[0]))
		) {
			infoBooking = ['error', 'wrong check-out date']
			error = true
			const toError = setTimeout(() => {
				error = false
			}, 2500)
			return false
		}
		checkinDate = start
		checkoutDate = end
		return true
	}

	const check_availability = async (r) => {
		if (!check_date()) return
		//reset old values
		overlap = false
		daysInSeason = 0
		total = 0

		//get the prices from sql
		const roomDetails = await get_room_details(r)
		const prices = roomDetails.prices
		const bookings = roomDetails.bookings
		guests = roomDetails.guests
		seasons = roomDetails.seasons
		breakfast = roomDetails.breakfast

		//only if there are booked days
		if (bookings !== null && bookings !== '' && bookings !== 'undefined') {
			let bookedDays = bookings.split(',')

			//check overlapping
			for (let i = 0; i < bookedDays.length; i++) {
				checkinDay = new Date(checkinDate[2], checkinDate[1] - 1, checkinDate[0])
				checkoutDay = new Date(checkoutDate[2], checkoutDate[1] - 1, checkoutDate[0])
				const periods = bookedDays[i].split('-')
				const startCompareArray = periods[0].split('/')
				const endCompareArray = periods[1].split('/')
				startCompDate = new Date(startCompareArray[2], startCompareArray[1] - 1, startCompareArray[0])
				endCompDate = new Date(endCompareArray[2], endCompareArray[1] - 1, endCompareArray[0])

				if (
					areIntervalsOverlapping({ start: checkinDay, end: checkoutDay }, { start: startCompDate, end: endCompDate })
				) {
					overlap = true
					break
				}
			}
		}

		if (overlap) {
			infoBooking = [
				'booked',
				'Sorry this room is already booked from ' +
					format(startCompDate, 'd/M/Y') +
					' - ' +
					format(endCompDate, 'd/M/Y'),
			]
			error = true
			const toError = setTimeout(() => {
				error = false
				clearTimeout(toError)
			}, 2500)
			return false
		}

		checkinDay = new Date(checkinDate[2], checkinDate[1] - 1, checkinDate[0])
		checkoutDay = new Date(checkoutDate[2], checkoutDate[1] - 1, checkoutDate[0])

		const seasonIntervals = seasons.map((season) => {
			const sStartArray = season.start.split('/')
			const sEndArray = season.end.split('/')
			const sStart = new Date(sStartArray[2], sStartArray[1] - 1, sStartArray[0])
			const sEnd = new Date(sEndArray[2], sEndArray[1] - 1, sEndArray[0])
			return [sStart, sEnd]
		})

		seasonIntervals.forEach((sI, index) => {
			const countSeasonDays = getOverlappingDaysInIntervals(
				{ start: seasonIntervals[index][0], end: seasonIntervals[index][1] },
				{ start: checkinDay, end: checkoutDay }
			)

			daysInSeason += countSeasonDays
		})
		//the total days booked
		totalDays = differenceInCalendarDays(checkoutDay, checkinDay)

		//the off season days
		daysOffSeason = totalDays - daysInSeason

		//calculate the prices
		const totalSeason = daysInSeason * parseFloat(prices[1])
		const totalOffSeason = daysOffSeason * parseFloat(prices[0])
		currency = prices[2]

		total = totalSeason + totalOffSeason
		total = new Intl.NumberFormat().format(total)

		infoBooking = ['booked', 'This room is available Total: ' + currency + ' ' + total]
		bookButton = true
		const toError = setTimeout(() => {
			error = false
		}, 4500)
	}

	const mk_booking = (r) => {
		if (!check_date()) return
		const bookingObject = {
			room: r,
			checkin: bookingDates.start,
			checkout: bookingDates.end,
			high: daysInSeason,
			low: daysOffSeason,
			totalDays: totalDays,
			currency: currency,
			total: total,
			guests: guests,
			breakfast: breakfast,
		}

		sessionStorage.setItem('booking', JSON.stringify(bookingObject))
		storeRoomConfirm.set(true)
	}

	const set_date = (e) => {
		if (e.detail.cmd === 'start') {
			bookingDates = {
				start: e.detail.value,
			}
		}
		if (e.detail.cmd === 'end') {
			bookingDates = { ...bookingDates, end: e.detail.value }
		}
	}

	//close the booking panel
	const close_book = () => {
		bookButton = false
	}
</script>

{#if !error && !bookButton}
	<div class="selector" use:styles={{ fsS }}>
		<div class="sub_title" use:styles={{ fsS }}>Check-in</div>
		<DatePicker
			cmd="start"
			selectionDate={true}
			backgroundColor="transparent"
			color={colorMain}
			colorDisabled="hsl(0,0%,50%)"
			disablePrevious={true}
			on:getdate={set_date}
		/>

		<div class="sub_title" use:styles={{ fsS }}>Check-out</div>
		<DatePicker
			cmd="end"
			selectionDate={true}
			backgroundColor="transparent"
			color={colorMain}
			colorDisabled="hsl(0,0%,50%)"
			disablePrevious={true}
			on:getdate={set_date}
		/>
	</div>

	<div class="button_container">
		{#if checkButton}
			<button on:click={() => check_availability(room)} use:styles={{ fsButton, buttonColor, buttonHover }}
				>check</button
			>
		{/if}
	</div>
{:else if error && !bookButton}
	<div class="response">
		<div class="error" use:styles={{ fsN, colorError }}>{[infoBooking[1]]}</div>
	</div>
{:else}
	<div class="response">
		<div class="success" use:styles={{ fsN, colorSuccess }}>{[infoBooking[1]]}</div>
	</div>
	<div class="button_container">
		<button on:click={() => mk_booking(room)} use:styles={{ fsButton, buttonColor, buttonHover }}>book</button>
		<button on:click={close_book} use:styles={{ fsButton, buttonColor, buttonHover }}>back</button>
	</div>
{/if}

<style>
	.selector {
		font-size: var(--fsS);
	}

	.sub_title {
		font-size: var(--fs);
		margin-bottom: 15px;
		margin-top: 20px;
	}

	.response {
		min-height: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		margin-top: 20px;
	}

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		font-size: var(--fsButton);
		color: var(--buttonColor);
		border: 1px solid white;
		border-radius: 10px;
		cursor: pointer;
		width: 100px;
		height: 30px;
		margin-left: 30px;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.error {
		font-size: var(--fsN);
		color: var(--colorError);
	}
	.success {
		font-size: var(--fsN);
		color: var(--colorSuccess);
	}
</style>
